// dependencies
import React, { useRef, useState, useEffect } from 'react'
import ReactTooltip from 'react-tooltip'
import papa from 'papaparse'

// import toast from '_root/lib/toast.js'
import PropTypes from 'prop-types'

// components
import { Button, BUTTON_THEME, Input, Icon } from '@st-operations/uikit/src/v2/index.js'

// lib
import { createApiKey } from '_services/source-partners'
import downloadCSV from '_lib/downloadCSV.js'
import toast from '@st-operations/uikit/lib/toast'
import { usePDPEnvironment } from '../../../../contexts/PDPEnvContext'
import copyToClipBoard from '../../../../lib/copyToClipBoard'

// styles
import './styles.scss'

// component
const NewApiKeyModal = ({ open, id, partnerName, createdBy, close }) => {
  const { pdpEnvironment } = usePDPEnvironment()

  const [inputValue, setInputValue] = useState('')
  const [downloadData, setDownloadData] = useState(null)

  const inputRef = useRef()

  useEffect(() => {
    if (open) {
      setInputValue('')
      setDownloadData(null)
    }
  }, [open])

  const download = () => {
    try {
      if (downloadData) {
        const fields = ['api_key', 'partner_id', 'name']
        const csv = papa.unparse({ fields, data: [downloadData] })
        downloadCSV(
          csv,
          `source_partner_${downloadData?.name}-${partnerName}-${pdpEnvironment.value}_api_key`
        )
        onDismiss()
        toast.success('Key downloaded successfully')
      }
    } catch (error) {
      toast.error('Error while downloading API key')
    }
  }

  const onCreate = async () => {
    try {
      if (!inputValue) {
        toast.error('Please enter a name for the API key')
        return
      }
      const response = await createApiKey({
        env: pdpEnvironment.value,
        id,
        created_by: createdBy,
        name: inputValue,
      })

      const data = {
        api_key: response.api_key,
        partner_id: id,
        name: inputValue,
      }

      setDownloadData(data)

      toast.success('API key created successfully. Please download the key now.')
    } catch (error) {
      toast.error('Error creating API key')
    }
  }

  const onDismiss = () => {
    close()
  }

  const onKeyDown = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      onCreate()
    }
    if (e.key === 'Escape' || (e.metaKey && e.key === 'e')) {
      e.preventDefault()
      onDismiss()
    }
  }

  const updateName = (value) => {
    setInputValue(value)
  }

  return (
    <section className="new-api-key-modal">
      <If condition={downloadData}>
        <div className="new-api-key-modal__download-modal">
          <h1 style={{ fontSize: '20px', fontWeight: '600' }}>
            This api secret access key is only available to download at this time. You will not be
            able to retrieve it later. If lost, create a new key.
          </h1>
          <div className="new-api-key-modal__download-modal__copy">
            <div>
              <span>Api Key : </span>
              <span style={{ fontSize: '16px', fontWeight: 400 }}>
                {downloadData?.api_key?.substring(0, 35) + '...'}
              </span>
            </div>
            <div
              style={{ cursor: 'pointer' }}
              data-tip
              data-for="copy-api-access-key"
              onClick={() => {
                copyToClipBoard(downloadData?.api_key)
                toast.success('Copied to clipboard successfully')
              }}
            >
              {' '}
              <Icon color="#02892dff" height="24px" icon="file" type="fill" width="24px" />
              <ReactTooltip id="copy-api-access-key" effect="solid">
                Copy to clipboard
              </ReactTooltip>
            </div>
          </div>
          <Button onClick={download}>Download Api Key</Button>
        </div>
      </If>
      <If condition={!downloadData}>
        <div>
          <h1>Create New Api key</h1>
          <Input
            placeholder="Enter name"
            ref={inputRef}
            onChange={updateName}
            onKeyDown={onKeyDown}
            value={inputValue}
            classes={{
              root: 'new-api-key-modal__input',
              input: 'new-api-key-modal__input-field',
            }}
          />
          <div className="new-api-key-modal__buttons">
            <Button
              className="new-api-key-modal__button"
              theme={BUTTON_THEME.SECONDARY}
              onClick={onDismiss}
            >
              Back
            </Button>
            <Button className="new-api-key-modal__button" onClick={onCreate}>
              Create
            </Button>
          </div>
        </div>
      </If>
    </section>
  )
}

NewApiKeyModal.propTypes = {
  open: PropTypes.bool,
  id: PropTypes.string,
  partnerName: PropTypes.string,
  createdBy: PropTypes.string,
  close: PropTypes.func,
}

NewApiKeyModal.defaultProperties = {
  open: false,
  id: '',
  partnerName: '',
  createdBy: '',
  close: () => {},
}

// export
export default NewApiKeyModal
